import { g1, t } from '@/locales/i18n'
import { computed } from 'vue'
import { getLinksAll, getLinksUrlLinks } from '@/composables/linksMixMethods'

export const useLinks = () => {
  const linksAll = computed(getLinksAll)
  const linksUrlLinks = computed(getLinksUrlLinks)

  const getUrlLinkHtml = (key: string, color = 'primary') => {
    if (!linksUrlLinks.value[key] || g1) return ''
    const { url, text } = linksUrlLinks.value[key]
    return t('common.link_text', { url, text, cssClass: `clr-${color}, text-underline_hover` })
  }

  return {
    linksAll,
    linksUrlLinks,
    getUrlLinkHtml,
  }
}
